// validationSchema.js
import * as yup from "yup";

export const appSchema = yup.object({
  //   firmware_link: yup
  //     .string()
  //     .url("Enter a valid URL")
  //     .required("Firmware link is required"),

  version: yup
    .string()
    .matches(/^[0-9]+\.[0-9]+\.[0-9]+$/, "Version must be in x.y.z format")
    .required("App version is required"),

  hash: yup
    .string()
    .min(32, "Hash must be at least 32 characters")
    .required("Hash is required"),
    
  forceUpdate: yup.boolean(),
});
